<div class="box-container small">

  <div class="box-header" [ngClass]="{'odd-animate' : Odd, 'even-animate' : !Odd}">
    {{Header}}
  </div>

  <div class="box-items-container">
    <app-knowledge-item [@showstate]="knowledge.state" [knowledge]="knowledge" *ngFor="let knowledge of KnowLedges"></app-knowledge-item>
  </div>
</div>